import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://jobcam.com.au";

export function useCanonical() {
  const { pathname } = useLocation();

  useEffect(() => {
    const url = `${BASE_URL}${pathname === "/" ? "" : pathname}`;

    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);

    // Keep og:url in sync with the canonical URL (the static default in index.html
    // otherwise leaves every page pointing at the homepage).
    let og = document.querySelector<HTMLMetaElement>('meta[property="og:url"]');
    if (!og) {
      og = document.createElement("meta");
      og.setAttribute("property", "og:url");
      document.head.appendChild(og);
    }
    og.setAttribute("content", url);
  }, [pathname]);
}
